 // 初始化
//  var vConsole = new VConsole();
//  console.log('Hello world');

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
// import ElementUI from 'element-ui';
import Antd from 'ant-design-vue';
import echarts from 'echarts'
import 'ant-design-vue/dist/antd.css';
import router from './router'
// import htmlToPdf from '@/utils/htmlToPdf'
import moment from 'moment';
import 'moment/locale/zh-cn';
import highcharts from 'highcharts'
import highcharts3d from 'highcharts/highcharts-3d'
import store from './store'

import Storage from 'vue-ls'
var storageOptions = {
    namespace: 'pro__', // key prefix
    name: 'ls', // name variable Vue.[ls] or this.[$ls],
    storage: 'local', // storage name session, local, memory
  }
Vue.use(Storage, storageOptions)

moment.locale('zh-cn');
Vue.use(Antd);
// Vue.use(htmlToPdf)
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false
// Vue.config.silent = true
highcharts3d(highcharts)
/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js